<!-- Guaranteed future value -->

<div class=" border rounded-lg shadow-sm newsletter-box mb-3 mt-2 p-2 text-center"
  *ngIf="vehicleValuation.garage.guaranteedFutureValue">
  {{'COMMON.LABEL.GUARANTEED_FUTURE_VALUE_DESCRIPTION' | translate}}
  <a [routerLink]="appSessionService.getTranslatedUrl('faq')">{{'COMMON.LABEL.DETAILS' | translate}}</a>
  <br>
  <mat-checkbox class="mt-2 mt-sm-0"
    [(ngModel)]="vehicleValuation.calculatorSettings.guaranteedFutureValue">
    {{'COMMON.LABEL.SIMULATE_FUTURE_VALUE_GUARANTEED' | translate}}
  </mat-checkbox>
</div>

<!-- duration selector -->
<div class="row my-2 px-2 align-items-center justify-content-between">
  <div class="col-auto">
    <div class="duration-label">{{'COMMON.LABEL.INVESTMENT_DURATION' | translate}}</div>
    <div class="mat-caption duration-label">*{{'COMMON.LABEL.SUGGESTED_DURATION' | translate}}</div>
  </div>

  <div class="col-auto">
    <mat-button-toggle-group [(ngModel)]="vehicleValuation.investmentDuration.length"
      aria-label="Durata investimento">
      <ng-container *ngFor="let investmentDuration of allInvestmentDurations">
        <mat-button-toggle [value]="investmentDuration"
          *ngIf="vehicleValuation.garage.getValuationForInvestmentDuration(investmentDuration)">
          <span class="d-none d-sm-inline">{{'COMMON.LABEL.' + investmentDuration | translate
            }}</span>
          <span class="d-sm-none">{{'COMMON.LABEL.' + investmentDuration + '_SHORT' | translate
            }}</span>
          <span *ngIf="vehicleValuation.suggestedInvestmentDuration.length === investmentDuration">*</span>
        </mat-button-toggle>
      </ng-container>
    </mat-button-toggle-group>
  </div>
</div>

<mat-divider>
</mat-divider>

<!-- gross gain -->
<div class="row my-2 px-2 justify-content-between">
  <div class="col-auto">
    {{'COMMON.LABEL.BUY_AT' | translate}}
  </div>
  <div class="col-auto">
    - {{vehicleValuation.buyPrice | number}}&euro;
  </div>
</div>

<mat-divider>
</mat-divider>

<div class="row my-2 px-2 justify-content-between">
  <div class="col-auto">
    {{'COMMON.LABEL.SELL_AT' | translate}}
  </div>
  <div class="col-auto">
    <span [ngClass]="{'text-stroked': vehicleValuation.calculatorSettings.guaranteedFutureValue}">
      {{vehicleValuation?.valuation?.sellPrice | number}}&euro;
    </span>
    <span *ngIf="vehicleValuation.calculatorSettings.guaranteedFutureValue">
      {{vehicleValuation.guaranteedFutureSellPrice | number}}&euro;
    </span>
  </div>
</div>

<mat-divider>
</mat-divider>

<div class="row my-2 px-2 justify-content-between sub-total">
  <div class="col-auto primary-base-color pr-0">
    {{'COMMON.LABEL.GROSS_GAIN' | translate}}
  </div>
  <div class="col-auto accent-base-color pl-0">
    {{vehicleValuation.gainInCash | number}}&euro; / +{{vehicleValuation.gainInPercentage |
    number}}%
  </div>
</div>

<mat-divider>
</mat-divider>

<h2 class="mb-1 mt-3">{{'COMMON.LABEL.COSTS' | translate}}</h2>

<!-- calculator settings -->
<div class="row mb-4">
  <div class="col-auto d-flex align-items-center pr-0">
    <mat-checkbox class="mr-1"
      [(ngModel)]="vehicleValuation.calculatorSettings.avoidInsurance">
      {{'COMMON.LABEL.AVOID_INSURANCE' | translate}}
    </mat-checkbox>
    <mat-icon [matTooltip]="'COMMON.LABEL.AVOID_INSURANCE_DETAILS' | translate">info</mat-icon>
  </div>

  <div class="col-auto d-flex align-items-center">
    <mat-checkbox class="mr-1"
      [(ngModel)]="vehicleValuation.calculatorSettings.useGarageService">
      {{'COMMON.LABEL.GARAGE_SERVICE' | translate}}
    </mat-checkbox>
    <mat-icon [matTooltip]="'COMMON.LABEL.GARAGE_SERVICE_DETAILS' | translate">info</mat-icon>
  </div>

  <!-- <div class="col-auto d-flex align-content-center mr-3">
                        <mat-slide-toggle class="mr-1"
                          color="accent"
                          [checked]="vehicleValuation.haveOtherCarsInsured">
                          {{'COMMON.LABEL.HAVE_OTHER_INSURED_VEHICLE' | translate}}
                        </mat-slide-toggle>
                        <mat-icon [matTooltip]="'COMMON.LABEL.AVOID_INSURANCE_DETAILS' | translate">info</mat-icon>
                      </div> -->
</div>

<!-- expenses calculation -->
<div class="row my-2 px-2 justify-content-between">
  <div class="col-auto">
    {{'COMMON.LABEL.CHANGE_OF_OWNERSHIP' | translate}}
  </div>
  <div class="col-auto">
    - {{vehicleValuation.changeOfOwnershipPrice | number}}&euro;
  </div>
</div>

<mat-divider>
</mat-divider>

<div class="row my-2 px-2 justify-content-between">
  <div class="col-auto">
    {{'COMMON.LABEL.CAR_TAX_COST' | translate}}
    <span>({{vehicleValuation.carTaxPricePerYear | number}}&euro; /
      {{'COMMON.LABEL.YEAR'
      |
      translate}})</span>
  </div>
  <div class="col-auto">
    - {{vehicleValuation.carTaxPrice | number}}&euro;
  </div>
</div>

<mat-divider>
</mat-divider>

<div class="row my-2 px-2 justify-content-between">
  <div class="col-auto">
    {{'COMMON.LABEL.INSURANCE_COST' | translate}}
    <span>({{vehicleValuation.insurancePricePerYear | number}}&euro; /
      {{'COMMON.LABEL.YEAR' |
      translate}})</span>
  </div>
  <div class="col-auto">
    - {{vehicleValuation.insurancePrice | number}}&euro;
  </div>
</div>

<mat-divider>
</mat-divider>

<ng-container *ngIf="vehicleValuation.maintenancePricePerYear">
  <div class="row my-2 px-2 justify-content-between">
    <div class="col-auto"
      [matTooltip]="'COMMON.LABEL.MAINTENANCE_COST_TOOLTIP' | translate">
      {{'COMMON.LABEL.MAINTENANCE_COST' | translate}}
      <span>({{vehicleValuation.maintenancePricePerYear | number}}&euro; /
        {{'COMMON.LABEL.YEAR' |
        translate}})</span>
    </div>
    <div class="col-auto">
      - {{vehicleValuation.maintenancePrice | number}}&euro;
    </div>
  </div>

  <mat-divider>
  </mat-divider>
</ng-container>

<ng-container *ngIf="vehicleValuation.calculatorSettings.useGarageService">
  <div class="row my-2 px-2 justify-content-between">
    <div class="col-auto">
      {{'COMMON.LABEL.GARAGE_SERVICE' | translate}}
      <span *ngIf="vehicleValuation.garagePricePerYear">({{vehicleValuation.garagePricePerYear |
        number}}&euro;
        /
        {{'COMMON.LABEL.YEAR'
        | translate}})</span>
    </div>
    <div class="col-auto">
      - {{vehicleValuation.garagePrice | number}}&euro;
    </div>
  </div>

  <mat-divider>
  </mat-divider>
</ng-container>

<div class="row my-2 px-2 justify-content-between sub-total">
  <div class="col-auto primary-base-color pr-0">
    {{'COMMON.LABEL.NET_GAIN' | translate}}
  </div>
  <div class="col-auto accent-base-color pl-0">
    {{vehicleValuation.netGainInCash | number}}&euro; / +{{vehicleValuation.netGainInPercentage |
    number}}%
  </div>
</div>

<mat-divider>
</mat-divider>

<div class="disclaimer mt-2">
  {{'COMMON.LABEL.PRICING_DISCLAIMER' | translate}}
</div>